import { batch } from 'react-redux';

import { createNamedActions } from 'utils/namedActionTypesProxy';

import { showMessageAction } from 'store/global/actions';

import { addTaskAction } from './tasks.actions';

export const FORM_TASK_ACTION_TYPE = createNamedActions('formTask', {
  SAVE_FORM_TASK_FIELDS_AS_DRAFT: 'SAVE_FORM_TASK_FIELDS_AS_DRAFT',
  RESET_FORM_TASK_FIELDS_DRAFT: 'RESET_FORM_TASK_FIELDS_DRAFT',
});

export const saveTaskFieldsAsDraftAction = payload => ({
  type: FORM_TASK_ACTION_TYPE.SAVE_FORM_TASK_FIELDS_AS_DRAFT,
  payload,
});

export const resetTaskFieldsDraftAction = () => ({
  type: FORM_TASK_ACTION_TYPE.RESET_FORM_TASK_FIELDS_DRAFT,
});

export const assignFormFromTaskDraftAction =
  ({ formBundleId, draftFields }) =>
  dispatch =>
    dispatch(
      addTaskAction({
        formBundleId,
        availableForAssignees: true,
        ...draftFields,
      }),
    ).then(result => {
      batch(() => {
        dispatch(showMessageAction({ message: 'Form assigned', variant: 'success' }));
        dispatch(resetTaskFieldsDraftAction());
      });

      return result;
    });
